import React from 'react';
import PropTypes from 'prop-types';

class Notification extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    open : this.props.open || false,
  }
  componentDidUpdate(prev_props) {
    if(this.props.open && !this.state.open) {
      this.setState({ open: true });
    }
    else if(prev_props.open && !this.props.open && this.state.open) {
      this.setState({ open: false });
      if(this.timer) {
        clearTimeout(this.timer);
      }
    };
  }
  componentWillUnmount() {
    if(this.timer) {
      clearTimeout(this.timer);
    }
  }
  render() {
    if(!this.props.iconClass) {
      return <noscript />
    }

    return(
      <li className={`${this.props.customButtonClass} ${this.props.className}`}>
        <a onClick={e => {
          e.preventDefault();
          this.setState({ open : !this.state.open }, f => {
            if(this.state.open) {
              if(this.props.onOpen) {
                this.props.onOpen();
              }
              this.timer = setTimeout(f => {
                this.setState({ open: false });
              }, 10000);
            }
            else {
              if(this.props.onClose) {
                this.props.onClose();
              }
            }
          });
        }} className={`dropdown-toggle notification-icon`}>
          <i className={`${this.props.iconClass} text-${this.props.status}`}></i>
          <span className="badge">{this.props.badge}</span>
        </a>

        <div
          className={`animated ${this.props.closing ? 'fadeOut' : 'fadeInDown'} dropdown-menu notification-menu large`} 
          style={{display : this.state.open? 'block': 'none'}}
          >
          <div className="notification-title">
            {this.props.badge ? (
              <span className="pull-right label label-default">{this.props.badge}</span>
            ) : null}
            {this.props.title}
          </div>
          <div className="content clearfix">
            {this.props.children}
          </div>
        </div>
      </li>
    );
  }
}

export default Notification;



// WEBPACK FOOTER //
// ./src/browser/components/header/notification.js